import createDelayedLoader from '../createDelayedLoader';
import PulseLoader from './PulseLoader';

const DelayedPulseLoader = createDelayedLoader(PulseLoader);

type DelayedPulseLoaderProps = React.ComponentPropsWithoutRef<
  typeof DelayedPulseLoader
>;

export default DelayedPulseLoader;
export type { DelayedPulseLoaderProps as PulseLoaderProps };
